import BN from 'bignumber.js'

function apply (Vue) {
    Vue.filter('floor', function (value, scale) {
        let s = (scale !== null && scale !== undefined) ? scale : 8;

        BN.set({ROUNDING_MODE:BN.ROUND_DOWN})

        return (new BN(value)).toFixed(s);
    });
}

export default {
    apply: apply,
};
